import { render, staticRenderFns } from "./FlagStatusMessageReason.vue?vue&type=template&id=0b02b5be&"
import script from "./FlagStatusMessageReason.vue?vue&type=script&lang=js&"
export * from "./FlagStatusMessageReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports